export default __webpack_public_path__ + "static/east-hokkaido-cycling-east-coast-003ff3ce15e72576f5d69496f5e561da.jpeg";